import { auth, db, storage } from "../../firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { doc, setDoc, arrayUnion } from "firebase/firestore";
import { get } from "react-hook-form";

export const writeDataS12 = async (pdfBlob) => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("No user is authenticated.");
  }

  try {
    // Step 2: Save the URL to Firestore
    const docRef = doc(db, "Advisers", user.uid, "Personal Details", "Data");
    await setDoc(
      docRef,
      {
        recruitmentApplication: true, // Mark the form as submitted
        recruitmentApplicationSubmittedAt: new Date(), // Save the timestamp
        recruitmentUpdates:[{
          date: new Date(),
          update: "Application Submitted",
          description: "",
        }],
      },
      { merge: true } // Merge with existing data
    );

    // console.log("PDF and form data successfully written to Firestore!");
  } catch (error) {
    // console.error("Error writing PDF data to Firestore: ", error);
  }
};
